import { Component } from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@material-ui/core'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null, hasError: false }
  }

  static getDerivedStateFromError(error) {
    return { error, hasError: true }
  }

  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ error: null, hasError: false })
    }
  }

  componentDidCatch(error) {
    console.error(error)
  }

  render() {
    const { children, fallback } = this.props
    const { error, hasError } = this.state

    if (hasError) {
      if (fallback) return fallback
      return (
        <Typography variant="h4">
          {`${error}` || 'Something went wrong!'}
        </Typography>
      )
    }

    return children
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
  fallback: PropTypes.element,
  resetKey: PropTypes.any,
}

export default ErrorBoundary
